import { render, staticRenderFns } from "./SrContactForm.vue?vue&type=template&id=bc80db7e&"
import script from "./SrContactForm.vue?vue&type=script&lang=js&"
export * from "./SrContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports